module.exports = __webpack_public_path__ + "img/led-wall-animation.291c6a72.png";